<script setup lang="ts">
import { AppButton, AppSvgIcon, AppFlicker } from '@libs/ui';

interface CarTripFooterDesktopProps {
  paxes: string;
  date?: string;
  fromPrice?: string;
}
const props = defineProps<CarTripFooterDesktopProps>();

interface CarTripFooterDesktopEmits {
  (event: 'show-suggested-trip'): void;
  (event: 'open-paxes'): void;
  (event: 'open-date'): void;
}
const emit = defineEmits<CarTripFooterDesktopEmits>();
</script>

<template>
  <div class="car-trip-footer-desktop">
    <div class="car-trip-info-wrapper">
      <div class="car-trip-info-summary">
        <div class="info" @click="emit('open-paxes')">
          <AppSvgIcon
            name="peopleOutlined"
            color="color-neutral-70"
            size="24"
          />
          <span class="value">{{ props.paxes }}</span>
        </div>
        <div class="info" @click="emit('open-date')">
          <AppSvgIcon
            name="calendarOutlined"
            color="color-neutral-70"
            size="18"
          />
          <span class="value">{{ props.date }}</span>
        </div>
      </div>
      <div class="car-trip-price">
        <span>{{ $t('planner.from') }}</span>
        <span v-if="props.fromPrice" class="amount">
          {{ props.fromPrice }}
        </span>
        <AppFlicker
          v-else
          height="spacing-32"
          width="spacing-96"
          border-radius="border-radius-20"
        />
      </div>
    </div>
    <AppButton
      type="important"
      state="enabled"
      size="large"
      @click="emit('show-suggested-trip')"
    >
      {{ $t('planner.show_suggested_trip') }}
    </AppButton>
  </div>
</template>

<style scoped lang="scss">
.car-trip-footer-desktop {
  background-color: var(--color-white);
  border-top: 1px solid var(--color-scrollbar);

  padding: var(--spacing-16) var(--spacing-24);
  display: flex;
  align-items: center;
  gap: var(--spacing-24);
  .car-trip-info-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: var(--spacing-24);
    .car-trip-info-summary {
      display: flex;
      gap: var(--spacing-24);
      .info {
        display: flex;
        align-items: center;
        gap: var(--spacing-12);
        @include on-hover {
          text-decoration: underline;
          cursor: pointer;
        }
        .value {
          @include font-heading-5;
          font-size: var(--font-size-16) / var(--line-heights-14);
        }
      }
    }
    .car-trip-price {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: var(--spacing-4);
      @include font-body-m-light;
      font-size: var(--font-size-14) / var(--line-heights-14);
      .amount {
        @include font-heading-3;
      }
    }
  }
}
</style>
